import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCabinet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCabinet"><Path d="M2 12V4H11.25V12H5.67905L4.37101 20.1099L2.89014 19.871L4.15966 12H2Z" fill="currentColor"/><Path d="M19.8403 12H22V4H12.75V12H18.321L19.629 20.1099L21.1099 19.871L19.8403 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCabinet;
